module.exports = __webpack_public_path__ + "img/P150T_weapon_145.7bdb8369.png";